import type { SegmentationSection } from './usePreferenceSections';
import type {
    EnrichedJobDetailsPreference,
    JobDetailsPreference,
    SegmentPreference,
} from '../types';

import { PreferenceType } from './usePreferenceTiles';

export const buildEnrichedJobDetailsPreferencesFrom = (
    segmentPrefs: SegmentPreference,
    knownUserSentimentIdMap: { [index: string]: string[] } = {},
): EnrichedJobDetailsPreference[] =>
    segmentPrefs.attributes?.map((pref) => ({
        label: pref.label,
        suid: pref.suid,
        prefIds: knownUserSentimentIdMap?.[pref.suid] ?? [],
        sentiment: pref.sentiment,
        tooltips: [],
        customClassLabels: [],
        customClassSuids: [],
    })) || [];

export const getJobTypeAndShiftSchedulePreferences = (
    jobTypes: JobDetailsPreference[],
    shiftsAndSchedule: JobDetailsPreference[],
): {
    jobTypeAndShiftSchedule: JobDetailsPreference[];
    preferenceToTypeMap: Map<string, PreferenceType>;
} => {
    const jobTypeAndShiftSchedule = [...jobTypes, ...shiftsAndSchedule];

    const preferenceToTypeMap = new Map();
    jobTypes.map((pref) => {
        preferenceToTypeMap.set(pref.suid, PreferenceType.JOB_TYPE);
    });
    shiftsAndSchedule.map((pref) => {
        preferenceToTypeMap.set(pref.suid, PreferenceType.SHIFT_AND_SCHEDULE);
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return { jobTypeAndShiftSchedule, preferenceToTypeMap };
};

export const getPreferenceListOfAllSegments = (
    segmentPreferences: SegmentPreference[],
    knownUserSentimentIdMap: { [index: string]: string[] } = {},
): {
    segmentPreferenceList: EnrichedJobDetailsPreference[];
    preferenceToSegmentationSectionMap: Map<string, SegmentationSection>;
} => {
    let segmentPreferenceList: EnrichedJobDetailsPreference[] = [];
    const preferenceToSegmentationSectionMap = new Map();

    segmentPreferences.map((segPrefModel) => {
        const segPrefList = buildEnrichedJobDetailsPreferencesFrom(
            segPrefModel,
            knownUserSentimentIdMap,
        );
        segmentPreferenceList = [...segmentPreferenceList, ...segPrefList];
        segPrefModel.attributes?.map((pref) => {
            preferenceToSegmentationSectionMap.set(pref.suid, segPrefModel.displayTitle);
        });
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return { segmentPreferenceList, preferenceToSegmentationSectionMap };
};
